import Draggable from './drag'

module.exports = (Vue) => {
    Vue.directive('drag', {
        bind: Draggable
    })
}


// WEBPACK FOOTER //
// ./src/directives/drag/index.js